import { sendButtonClick } from '@/services/tracking'
import { useGlobalStore } from '@/stores/global'
import type { DirectiveBinding } from 'vue'
import { trackingEnabled } from '@/services/tracking-sessions'

const clickHandlers = new WeakMap<HTMLElement, EventListener>()

function setTrackingID(el: HTMLElement, id: string | undefined) {
  if (id) {
    el.dataset.trackId = id
    return
  }

  delete el.dataset.trackId
}

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding<string>) {
    const globalStore = useGlobalStore()

    const id = binding.value
    if (!id) {
      console.warn('v-track: missing ID')
      return
    }

    setTrackingID(el, id)

    if (!trackingEnabled) return

    const handler = () => {
      const eventName = el.dataset.trackId
      const visitId = globalStore.currentVisitId
      if (!eventName || !visitId) return
      void sendButtonClick(eventName, visitId)
    }

    clickHandlers.set(el, handler)
    el.addEventListener('click', handler)
  },

  updated(el: HTMLElement, binding: DirectiveBinding<string>) {
    setTrackingID(el, binding.value)
  },

  beforeUnmount(el: HTMLElement) {
    const handler = clickHandlers.get(el)
    if (!handler) return
    el.removeEventListener('click', handler)
    clickHandlers.delete(el)
  }
}
